import { lazy, Suspense, Component, type ReactNode } from "react";
import Hero from "@/components/Hero";

const Navbar = lazy(() => import("@/components/Navbar"));
const About = lazy(() => import("@/components/About"));
const Services = lazy(() => import("@/components/Services"));
const Projects = lazy(() => import("@/components/Projects"));
const ConstructionProgress = lazy(() => import("@/components/ConstructionProgress"));
const Contact = lazy(() => import("@/components/Contact"));
const Footer = lazy(() => import("@/components/Footer"));

class SectionErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error: Error) {
    console.error("Section failed to load:", error);
  }
  render() {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

const SafeSection = ({ children }: { children: ReactNode }) => (
  <SectionErrorBoundary>
    <Suspense fallback={null}>{children}</Suspense>
  </SectionErrorBoundary>
);

const Index = () => (
  <div className="min-h-screen">
    <SafeSection>
      <Navbar />
    </SafeSection>
    <SafeSection><Hero /></SafeSection>
    <SafeSection><About /></SafeSection>
    <SafeSection><Services /></SafeSection>
    <SafeSection><Projects /></SafeSection>
    <SafeSection><ConstructionProgress /></SafeSection>
    <SafeSection><Contact /></SafeSection>
    <SafeSection><Footer /></SafeSection>
  </div>
);

export default Index;
